/// Ce script est également appelé
/// sur la page de création spontanée de l'espace client
class Compte extends Inscription {

	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize() {
		let self = this;

		const utilities = new utilitiesInscription(config);
		const formulaire = new Formulaire(config.form);

		let objSelectors = {
			form: document.getElementById('RegisterForm'),
			idForm: 'RegisterForm',
			btnConnexionCompte: document.getElementById('goToCoord')
		}
		let dataRequired = ['Civilite', "Nom", "Prenom", "DateNaissance", "Pays", "NumeroLibelleVoie", "CodePostal", "Ville", "Email", "Password"];

		let dqeObj = {
			server: "jsonp",
			license: "TERDAV",
			single: "#NumeroLibelleVoie",
			zip: "#CodePostal",
			city: "#Ville",
			compl: "#ComplementImmeuble",
			street: "#NumeroLibelleVoie",
			local: "#Adresse4",
			country: "#Pays"
		}

		/// On lance les fonctions génériques (récap, tunnel)
		/// uniquement sur le tunnel d'achat (et non sur account/creation)
		if (this.config.path === 'tunnel') {
			super.initialize();
		} else if (this.config.page === 'creation') {
			objSelectors.btnConnexionCompte = document.getElementById('goToEspaceClient');
		} else if (this.config.page === 'password') {
			dataRequired = ['Email']
			objSelectors = {
				form: document.getElementById('LightPasswordRenew'),
				idForm: 'LightPasswordRenew',
				btnConnexionCompte: document.getElementById('btnValider')
			}
		} else if (this.config.page === 'passwordactivation') {
			dataRequired = ['Password', 'ConfirmPassword']
			objSelectors = {
				form: document.getElementById('PasswordActivation'),
				idForm: 'PasswordActivation',
				btnConnexionCompte: document.getElementById('btnvalider')
			}
		}
		/// Création d'un espace client dans le tunnel d'achat
		/// Création spontanée d'un espace client
		if (this.config.page === 'creation') {
			settingsApp.modules.moduleIndicatifTel.then(() => {
				const tel = require(`modules/indicatifTelephonique`);
				let indicatifTel = new tel();
				indicatifTel.initialize();
			});
			//this.indicatifTelephonique(false, null);
			//!this.config.IsCreated && this.indicatifPays();
			formulaire.dqe('RegisterForm', dqeObj);
			//this.complementTel();
			utilities._maskInput('#DateNaissance');
			formulaire.initialize(objSelectors.idForm);

			document.querySelector('[data-form-submit]').addEventListener('click', function (e) {
				if (formulaire._isFormValid(document.getElementById('RegisterForm'))) {
					e.preventDefault();
					formulaire.launchModale(self.Register);
				}
			})
		}

		//super._formAnimation();

		utilities.initialize();

		// let arrayId2 = ['password', 'passwordactivation'];
		// if (arrayId2.includes(config.page)) {
		// 	self._setValidBtn(dataRequired, objSelectors);
		// 	objSelectors.form.addEventListener("input", function () {
		// 		self._setValidBtn(dataRequired, objSelectors);

		// 		if (config.page === 'passwordactivation') {
		// 			let isValid = document.getElementById(dataRequired[0]).value === document.getElementById(dataRequired[1]).value;
		// 			if (isValid) {
		// 				objSelectors.btnConnexionCompte.classList.remove('is-disabled');
		// 			} else {
		// 				objSelectors.btnConnexionCompte.classList.add('is-disabled');
		// 			}
		// 		}
		// 	});
		// }
	}

	/// On met à jour le bouton de validation
	// _setValidBtn(data, el) {
	// 	const utilities = new utilitiesInscription(config);
	// 	let isValid = utilities.checkForm(el.idForm, data);

	// 	if (isValid) {
	// 		el.btnConnexionCompte.classList.remove('is-disabled');
	// 	} else {
	// 		el.btnConnexionCompte.classList.add('is-disabled');
	// 	}
	// }

	indicatifTelephonique(isCallback, value) {

		let self = this;
		let selectindicatif = document.querySelectorAll('.select--indicatif');

		selectindicatif.forEach(function (el) {
			let box = el.parentElement.querySelector('.box-input');
			if (isCallback) {
				el.value = value;
				self._boxInput(el, box)
			} else {
				el.addEventListener('change', function (element) {
					self._boxInput(element.target, box)
				})
			}
		});
	}

	indicatifPays() {
		let self = this;
		let selectindicatifPays = document.getElementById('Pays');

		selectindicatifPays.addEventListener('change', function () {
			let value = this.options[this.selectedIndex].value;
			self.indicatifTelephonique(true, value)
		});
	}

	_boxInput(el, box) {
		let text = el.options[el.selectedIndex].text;
		if (text != '----' && text != '--') {
			let value = text.split('(');
			let indicatifNumerique = value[1].slice(0, -1);
			if (box != null) {
				box.innerText = indicatifNumerique;
			}
		} else {
			box.innerText = '';
		}
	}


	Register() {
		var token = $('[name=__RequestVerificationToken]').val();
		var headers = {};
		headers["__RequestVerificationToken"] = token;
		//$('#erreurEmaildejaExistant').html("");

		$.ajax({
			url: config.url.register,
			async: false,
			type: 'POST',
			headers: headers,
			data: $('#RegisterForm').serialize(),
			success: function (data) {
				if (data == 1) {

					// succes creation espace client via tunnel achat
					window.location.href = config.url.coord;
				} else if (data == 2) {
					// le mail existe deja en base, on le redirige vers la connexion

					let message = `Il existe déjà un espace client associé à cette adresse email. Si vous êtes le propriétaire de cet espace, <a href="${config.url.connexion}">cliquer ici</a> pour vous connecter.`;
					$('#erreurEmaildejaExistant').html(message);
				} else {

					$("#creation-compte").html(data);
				}
			}
		});
	}
}